"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
class SettingsServiceImpl extends api_shared_js_1.ServiceImplBase {
    get serviceName() {
        return "SettingsService" /* SettingsService */;
    }
    saveSettingsAsync(settings) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'saveSettingsAsync',
            [api_internal_contract_js_1.ParameterId.SettingsValues]: settings,
        };
        return this.execute(api_internal_contract_js_1.VerbId.SaveExtensionSettings, parameters).then((value) => {
            const result = value.result;
            if (!result || !result.settingsValues) {
                throw new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.InternalError, 'Unexpected error savings settings.');
            }
            return result.settingsValues;
        });
    }
}
exports.SettingsServiceImpl = SettingsServiceImpl;
//# sourceMappingURL=SettingsServiceImpl.js.map